import React, { memo, ReactElement } from "react";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";

import { textFormatter } from "../../../util/text-formatter";
import { selectTweetContentBlurred, selectTweetText } from "../../../store/ducks/tweet/selectors";
import { useTweetTextStyles } from "./TweetTextStyles";

const TweetText = memo((): ReactElement => {
    const classes = useTweetTextStyles();
    const tweetText = useSelector(selectTweetText);
    const isContentblurred = useSelector(selectTweetContentBlurred);

    const preventActions = (e: any) => {
        if (isContentblurred) {
            e.preventDefault();
            return false;
        }
    }
    
    return (
        <Typography
            variant={"h3"}
            onCopy={preventActions} // Prevent copying
            onContextMenu={preventActions} // Prevent right-click
            className={classes.text}
            style={{ filter: isContentblurred ? "blur(10px)" : "none", userSelect: isContentblurred ? "none" : "auto" }}
        >
            {textFormatter(tweetText!)}
        </Typography>
    );
});

export default TweetText;
